export default "__VITE_ASSET__C8Qn$Anm__"